// import { Injectable } from '@angular/core';
// import { API } from 'app/constant';
// import { AuthService } from 'app/core/auth/auth.service';
// import { io, Socket } from 'socket.io-client';

// export interface ChatResponse {
//     status: number;
//     recordList: any[]; // You can refine this type based on your actual chat object structure
// }

// @Injectable({
//     providedIn: 'root',
// })
// export class SocketService {
//     private socket: Socket;
//     private agentId: number;

//     constructor(private authService: AuthService) {}

//     connect(agentId: number): Promise<void> {
//         return new Promise((resolve, reject) => {
//             if (this.socket && this.socket.connected) {
//                 console.log(
//                     `Socket already connected for agent ${this.agentId}`
//                 );
//                 resolve();
//                 return;
//             }

//             this.agentId = agentId;
//             const token = this.authService.SessionToken;
//             if (!token) {
//                 console.error(
//                     'No session token available for socket connection'
//                 );
//                 reject(new Error('No session token'));
//                 return;
//             }

//             this.socket = io(API.BASE_URL, {
//                 auth: { token },
//                 reconnection: true,
//                 reconnectionAttempts: 5,
//                 reconnectionDelay: 1000,
//             });

//             this.socket.on('connect', () => {
//                 console.log(
//                     `Socket connected successfully for agent ${this.agentId}`
//                 );
//                 this.setInitialStatus();
//                 resolve();
//             });

//             this.socket.on('connect_error', (error) => {
//                 console.error(
//                     `Socket connection error for agent ${this.agentId}:`,
//                     error
//                 );
//                 reject(error);
//             });

//             this.socket.on('disconnect', () => {
//                 console.log(`Socket disconnected for agent ${this.agentId}`);
//             });
//         });
//     }

//     disconnect(): void {
//         if (this.socket) {
//             this.socket.disconnect();
//             console.log(
//                 `Socket disconnected manually for agent ${this.agentId}`
//             );
//         }
//     }

//     getSocket(): Socket {
//         if (!this.socket) {
//             console.warn('Socket not initialized. Call connect() first.');
//         }
//         return this.socket;
//     }

//     private setInitialStatus(): void {
//         this.socket.emit('agentInitialStatus', {
//             agentId: this.agentId,
//             status: 'away',
//         });
//     }
// }


import { Injectable } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SocketService {
    constructor(private authService: AuthService) {}

    on(eventName: string): Observable<any> {
        return new Observable((subscriber) => {
            const socket = this.authService.socket;
            if (socket) {
                socket.on(eventName, (data) => {
                    subscriber.next(data);
                });
            } else {
                console.warn('SocketService: Socket is not initialized in AuthService.');
                // Optional: We could subscribe to a 'socketConnected' event from AuthService if it existed,
                // but for now, we assume AuthGuard ensures connection.
            }

            // Cleanup logic if needed, validation of socket connection
            return () => {
                if (socket) {
                    socket.off(eventName);
                }
            };
        });
    }

    emit(eventName: string, data: any): void {
        const socket = this.authService.socket;
        if (socket) {
            socket.emit(eventName, data);
        } else {
             console.warn('SocketService: Cannot emit, socket not connected.');
        }
    }
}
